export type RdsCodeSortType = 'VALUE' | 'NAME' | 'NATURAL';
export type RdsCodeSortDirection = 'ASC' | 'DESC';

export class RdsTabulationSortOptions {
  constructor(
    public rowType: RdsCodeSortType = 'VALUE',
    public rowDirection: RdsCodeSortDirection = 'ASC',
    public colType: RdsCodeSortType = 'VALUE',
    public colDirection: RdsCodeSortDirection = 'ASC'
  ) {}
}

export function isRdsCodeSortType(something: unknown): something is RdsCodeSortType {
  return !!something && (something === 'VALUE' || something === 'NAME' || something === 'NATURAL');
}

export function isRdsCodeSortDirection(something: unknown): something is RdsCodeSortDirection {
  return !!something && (something === 'ASC' || something === 'DESC');
}
